import React from 'react'
import styled from 'styled-components'
import EditButton from './EditButton'

const Button = styled.div`
    background-color: ${props => props.background};
    color: #FFFFFF;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 35px;
	line-height: 35px;
    text-align: center;
    font-size: 12px;
    width: 200px;
    box-sizing: border-box;
    border-radius: 2px;
    letter-spacing: 2px;
    text-transform: uppercase;
    cursor: pointer;
    user-select: none;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
        0px 2px 2px 0px rgba(0,  0, 0, 0.14),
        0px 1px 5px 0px rgba(0, 0, 0, 0.12);

    :first-child {
        margin-right: 20px;
    }
`

const Buttons = styled.div`
    position: relative;
    display: inline-flex;

    button {
        display: none;
    }

    :hover {
        button {
            display: inline-flex;
        }
    }
`

export default ({type, id, data, onEdit}) => {
    const handleClick = () => {
        onEdit(type, id, data)
    }

    return (
        <Buttons>
            <Button background='#00D084'>
                {data.positive}
            </Button>
            <Button background='#D45B4A'>
                {data.negative}
            </Button>
            <EditButton onClick={handleClick} />
        </Buttons>
    )
}
